/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_Editor_DescInputs */



/**
* | output |
* | --- |
* | "Creates and edits projects" |
*
* @param {Team_Manager_Role_Editor_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_editor_desc = /** @type {((inputs?: Team_Manager_Role_Editor_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_Editor_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Crée et modifie des projets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt und bearbeitet Projekte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea e modifica progetti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создаёт и редактирует проекты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crea y edita proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建和编辑项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを作成・編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट बनाता और संपादित करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cria e edita projetos")
	return /** @type {LocalizedString} */ ("Creates and edits projects")
});